"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    empty: "请补充该项内容",
    length: "请输入{length}位字符",
    minLength: "输入内容至少{minLength}位",
    number: "请输入数字",
    int: "请输入整数",
    lt: "输入内容应小于{lt}",
    lte: "输入内容不能大于{lte}",
    gt: "输入内容应大于{gt}",
    gte: "输入内容不能小于{gte}",
    maxDecimalLength: "该输入项最多接受{maxDecimalLength}位小数",
    phone: "请输入正确的手机号",
    email: "请输入正确的邮箱",
    verifyCode: "请输入正确的验证码"
};
